import { render, staticRenderFns } from "./MembershipHistory.vue?vue&type=template&id=e4e64536"
import script from "./MembershipHistory.vue?vue&type=script&lang=js"
export * from "./MembershipHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports